export default __webpack_public_path__ + "images/arrow-brown-icon.svg?f99fbf47b7a4661f60bf76692602ce94";